<script>
import resources from './resources'

export default {
  name: 'scheduling-transfer',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row
    .col-xs-12.col-sm-10.col-sm-offset-1
      h4 DEFINA A NOVA DATA PARA A TRANSFERÊNCIA DESTE AGENDAMENTO
      .row.border-bottom
        .col-xs-12.dark-grey(style='margin-bottom:15px;') Dados do Agendamento Atual:
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Dia
          br
          span.blue {{ formatDate(schedule.date) }} ({{ dayOfWeek }})
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Hora
          br
          span.blue {{ schedule.time }}
        .clearfix
        div(style='height:15px;')
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Nome do Profissional
          br
          span.blue {{ schedule.professional.name }}
          small.grey Especialidade Médica
          br
          span.blue
            |{{ schedule.speciality }}
          .endereco
            br
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Nome do Paciente
          .blue {{ schedule.patient.name }}
          small.grey Grau de Parentesco
          span.blue {{ schedule | getValue('patient.degree.name') }}

      .row.border-bottom
        .col-xs-12.dark-grey(style='margin-bottom:15px;') Dados da Transferência:
        .col-xs-12(style='margin-bottom:15px;')
          v-input(:status="$v.to.agenda_id.$error ? 'error' : null")
            f-select-professional-agenda(
             label="Selecione uma Agenda",
             name="agenda_id",
             v-model="to.agenda_id",
             :searchable="true",
             :get-all="true",
             placeholder="Selecione uma agenda",
             :parameters-show="{includes: ['next_30dates']}",
             @selected="setDates",
             :errors="errors['agenda_id']")

        .col-xs-12
          v-input(:status="$v.date.$error ? 'error' : null", v-if="to.agenda_id")
            f-select(v-if="to.agenda_id",
              :options="dates",
              v-model="date",
              :searchable="false",
              label="Informe uma Nova Data de Agendamento",
              @input="onSelectedDate")

        .col-xs-12
          v-input(:status="$v.to.schedule_id.$error ? 'error' : null", v-if="date && getTimes")
            f-select-professional-schedules-times(
              :parameters="{agenda_id: to.agenda_id, date}",
              :get-all="true",
              :searchable="false",
              v-if="date && getTimes",
              v-model="to.schedule_id",
              label="Selecione um horário"
          )
      .buttons-wrapper
        button.btn.cancel(data-dismiss='modal')
          span.icon 
          |  Cancelar
        button.btn.save-filled(@click.prevent="doTransfer")
          span.icon 
          |  Transferir Agendamento
</template>



// WEBPACK FOOTER //
// src/app/professional/dashboard/company/gadget/components/active-agenda/components/transfer/transfer.vue